import Vue from 'vue'
import Router from 'vue-router'
import native from '@zz-common/native-adapter'
import { getCookie, getParamsByCookie, isPhoneOrPad, isDigital, isLaptop, locationReplace } from '@/utils/helper'
import { lego } from '@zz-common/lego'
import Login from '@/utils/login.js'
import { helpsaleDefaultUrl } from '@/conf/url.conf'
import { bmMainUrl } from '../conf/url.config';
import { getUserIpInfoAjax } from '@/apiData/helpsale/d2d-gps'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

const context = require.context('.', false, /\.js$/)
let configRoutes = []
context.keys().forEach((key) => {
  const ignoreKeys = ['./index.js']
  if (ignoreKeys.includes(key)) return
  configRoutes = configRoutes.concat(context(key).default)
})

/**
 * 从routes中获取需要统计数据的路由列表（在route的meta中配置了pageId）
 */
const legoRouteList = []
const generatePageIdConfig = (routes, parentPath = '') => {
  routes
    .forEach((item) => {
      const { path, name = '', alias, meta, children } = item
      const route = `/${parentPath}/${path}`.replace(/\/+/g, '/') // 防止出现多个连续斜杠
      if (route && children) {
        return generatePageIdConfig(children, route)
      }
      const { pageId, level = 1, isAutoPV } = meta || {}
      if (pageId) {
        legoRouteList.push({ name, route, pageId, level, isAutoPV })
        if (alias) { // 存在路由别名的话就多存一份
          legoRouteList.push({ name, route: alias, pageId, level, isAutoPV })
        }
      }
    })
}
generatePageIdConfig(configRoutes)
/**在此处对 RouteList 进行排序，由于 RouteList 匹配原则的问题，类似 “/proto-novV2” 的路由必须放在 “/proto-nov” 的前边 */
legoRouteList.sort((a, b) => b.route.length - a.route.length);
console.log('legoRouteList: ', legoRouteList);
export { legoRouteList }
let referrer = (document && document.referrer) || ''

const getCityInfoForLego = async (pageId) => {
  const targetPageIds = ['C8524', 'Q8688', 'T1080', 'N1081', 'T1082', 'J7832', 'A7327', 'A5341']
  if (!targetPageIds.includes(pageId)) return {}

  try {
    const res = await getUserIpInfoAjax({
    })
    if (res && res.cityName) {
      return { cityName: res.cityName }
    }
  } catch (error) {
    console.log('get city error', error)
  }
  return {}
}

const sendLegoIntoPage = async (route) => {
  const { cateId, bmFrom, channel, servicefrom } = route.query || {}

  const routeName = route.name || 'empty'
  const logsMark = `U_BM-Main_${routeName}` // 埋点标识
  // 获取页面的 referrer 信息，埋点计算漏斗
  try {
    // 由于客户端内无法获取 referrer 信息，故获取cookie中链接栈信息，每次打开一个页面默认在栈尾插入一条
    if (!referrer) {
      let zzVisitStack = getCookie('zzVisitStack')
      zzVisitStack = (zzVisitStack && JSON.parse(zzVisitStack)) || []
      if (zzVisitStack.length > 1) {
        const length = zzVisitStack.length
        referrer = zzVisitStack[length - 2]?.href || ''
        referrer = decodeURIComponent(referrer)
      }
    }
  } catch (error) {
    console.log('zzVisitStack error: ', error)
  }

  // 特定页面上报城市信息
  const pageId = route.meta?.pageId
  const cityInfo = await getCityInfoForLego(pageId)

  const legoParams = getParamsByCookie()
  // 判断品类类型
  let isCateTypeById = {}
  if (cateId) {
    isCateTypeById = {
      isPhoneOrPad: isPhoneOrPad(cateId),
      isDigital: isDigital(cateId),
      isLaptop: isLaptop(cateId),
      isDigitalWithLaptop: isDigital(cateId) || isLaptop(cateId)
    }
  }
  const backup = {
    ...legoParams,
    ...isCateTypeById,
    ...cityInfo,
    pageCateId: cateId,
    logsMark,
    referrer,
    channel: channel || window.localStorage.getItem('channel'),
    servicefrom: window.localStorage.getItem('servicefrom') || servicefrom
  }
  bmFrom && (backup.bmFrom = bmFrom)
  const actiontype = routeName.toUpperCase() + '__SHOW'
  console.log('actiontype: ', actiontype);
  lego.send({
    actiontype: `${pageId}_SHOW`,
    backup
  })
  setTimeout(() => {
    lego.send({
      // pagetype: `BM-${routeName.toUpperCase()}`,
      actiontype,
      backup
      // isShow: true
    })
  }, 300)
}

export default (() => {
  const router = new Router({
    mode: 'history',
    base: '/u/bmmain',
    scrollBehavior(to, from, savedPosition) {
      const { name } = to
      if (name === 'auctionroom-item' || name === 'auctionroom-history') {
        return { x: 0, y: 0 }
      } else {
        return savedPosition
      }
    },
    routes: [
      {
        path: '*',
        name: 'default-index',
        beforeEnter: () => {
          locationReplace(bmMainUrl.typeSelect)
        }
      },
      ...configRoutes
    ]
  })

  router.beforeEach((to, from, next) => {
    //servicefrom客服入口标识
    try {
      let { channel = '', type, servicefrom } = to.query || {}
      // C方案已下掉，已投放链接默认跳转页面设置
      if (to.name === 'helpsale-correlate' && type !== 'B') {
        native.skipToUrl({
          targetUrl: `${helpsaleDefaultUrl}&channel=${channel}`,
          needClose: 1
        })
      }

      // 设置业务线自定义channel，避免重复，添加 "BM_"前缀，涉及到pm数据统计，谨慎修改 by zhangying
      // channel 在链接上有多个时，query 获取到的是数组，此处特殊处理
      if (Array.isArray(channel)) {
        channel = channel.find(i => i)
      }

      if (!String.prototype.startsWith.call(channel, 'JM') && channel?.toUpperCase()?.indexOf('BM') === -1) {
        channel = `BM_${channel}`
      }
      console.log('埋点中channel添加业务前缀', channel)
      if (channel) {
        channel = channel.indexOf('-') > -1 ? channel.replace('-', '_') : channel
        channel = channel.toUpperCase()
        window.localStorage.setItem('channel', channel)
      }
      if (servicefrom) {
        window.localStorage.setItem('servicefrom', servicefrom)
      }
      console.log('name: ', to.name);
      if (native.in('zz') && to.name !== from.name) {
        native.wrap('resetRightAllButton')()
      }
    } catch (error) {
      console.log('error: ', error);
    }

    next()
  })

  // 路由结束设置页面标题
  router.afterEach((route) => {
    const { title, needLogin } = route.meta
    title && native.setTitle({ title })

    const { isPreRender } = route.query || {}
    // 预渲染情况下不调起登录/发埋点
    if (isPreRender == 1) return

    if (needLogin) {
      Login()
        .then(() => {})
        .catch((e) => {
          console.log('e: ', e);
          native.wrap('close')()
        })
    }
    sendLegoIntoPage(route)
  })

  return router
})()
